import { fetchAllIconsFromKodefastAPI } from '@/repo/iconsRepo';
const initialState = () => {
  return {
    apiIcons: [],
  };
};

const state = initialState();

const getters = {
  getApiIcons: (state) => state.apiIcons,
};

const mutations = {
  setApiIcons(state, icons) {
    state.apiIcons = icons;
  },
  resetData: (state) => {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const actions = {
  fetchApiIcons: async (context) => {
    try {
      const icons = await fetchAllIconsFromKodefastAPI();
      context.commit('icons/setApiIcons', icons, { root: true });
    } catch (error) {
      context.commit('icons/setApiIcons', [], { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
